module.exports = __webpack_public_path__ + "fonts/Roboto-Light.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Roboto/Roboto-Light.woff2
// module id = 3458
// module chunks = 0